import { render } from "./role-permission-modal.vue?vue&type=template&id=a6b85a1c"
import script from "./role-permission-modal.vue?vue&type=script&lang=js"
export * from "./role-permission-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__